// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class NoteTypeModel {
    static getAttributeTypeMap() {
        return NoteTypeModel.attributeTypeMap;
    }
}
NoteTypeModel.discriminator = undefined;
NoteTypeModel.attributeTypeMap = [
    {
        "name": "typeId",
        "baseName": "typeId",
        "type": "number"
    },
    {
        "name": "typeCategory",
        "baseName": "typeCategory",
        "type": "NoteTypeCategory"
    },
    {
        "name": "modifiedBy",
        "baseName": "modifiedBy",
        "type": "number"
    },
    {
        "name": "typeCode",
        "baseName": "typeCode",
        "type": "string"
    },
    {
        "name": "typeDescription",
        "baseName": "typeDescription",
        "type": "string"
    }
];
//# sourceMappingURL=noteTypeModel.js.map